<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="2.2" stepTitle="房型/价格计划"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">价格计划</span>
              <span class="card-txt">房型名称：{{ optionName }}</span>
            </a-col>
          </a-row>
          <a-button :disabled="proSource!=0" class="mr5" type="primary" @click="onPlanUpdate(0)">新建计划</a-button>
          <custom-page-table
            style="margin-top: 15px;"
            ref="table"
            rowKey="ratePlanId"
            :queryParams="queryParams"
            :requestPromise="loadPromise"
            :columns="columns"
          >
            <template slot="statusSlot" slot-scope="rowItem">
              {{ rowItem.record.ratePlanStatus | getProOptionStatusStr }}
            </template>
            <span slot="action" slot-scope="rowItem">
              <a v-if="rowItem.record.ratePlanStatus==1" @click="handlePlan(rowItem.record.ratePlanId,0)"
                 :disabled="proSource!=0">下架</a>
              <a v-else :disabled="proSource!=0" @click="handlePlan(rowItem.record.ratePlanId,1)">上架</a>
              <a-divider type="vertical"></a-divider>
              <a @click="goSetPrice(rowItem.record.ratePlanId)">价格库存</a>
              <a-divider type="vertical"></a-divider>
              <a @click="onPlanUpdate(rowItem.record.ratePlanId)">编辑</a>
              <a-divider type="vertical"></a-divider>
              <a-popconfirm title="是否要删除当前行" @confirm="onDeleteType(rowItem.record.ratePlanId)">
                <a :disabled="proSource!=0">删除</a>
              </a-popconfirm>
            </span>
          </custom-page-table>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import PublishPro from '../components/PublishPro'

export default {
  name: 'HotelPricePlan',
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro
  },
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      optionName: this.$route.query.optionName,
      catalogId: this.$route.query.catalogId,
      optionId: this.$route.query.optionId,
      queryParams: {
        proId: this.$route.query.proId,
        optionId: this.$route.query.optionId
      },
      columns: [
        {
          title: '计划编号',
          dataIndex: 'ratePlanId'
        }, {
          title: '计划名称',
          dataIndex: 'ratePlanName'
        }, {
          title: '建议销售价',
          dataIndex: 'advicePrice'
        }, {
          title: '同行价',
          dataIndex: 'auditPrice'
        }, {
          title: '状态',
          dataIndex: 'ratePlanStatus',
          scopedSlots: { customRender: 'statusSlot' },
          fixed: 'right'
        }, {
          title: '操作',
          dataIndex: 'action',
          width: '250px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getListPromise(params),
      selectedStr: '',
      optionTitle: ''
    }
  },
  mounted() {

  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getProService().post('api/v2/productManage/findRatePlanList', params)
    },
    handlePlan(id, status) {
      let text = status == 1 ? '上架' : '下架'
      this.getHttpServices().getProService().post('product/hotel/RatePlan/ratePlanOnOrUnder', {
        ratePlanId: id,
        status: status
      }).then(res => {
        this.getLogUtils().logWithTag('handlePlan', res)
        this.$message.success(text + '成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onDeleteType(id) {
      this.getHttpServices().getProService().post('product/hotel/RatePlan/delRatePlan/' + id).then(res => {
        this.getLogUtils().logWithTag('onDeleteType', res)
        this.$message.success('删除成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onPlanUpdate(ratePlanId) {
      this.$router.push({
        name: 'HotelPlanInfo',
        query: {
          proId: this.proId,
          optionId: this.optionId,
          catalogId: this.catalogId,
          ratePlanId: ratePlanId,
          proSource: this.proSource,
          optionName: this.optionName
        }
      })
    },
    goSetPrice(ratePlanId) {
      let name = ''
      if (this.proSource == 0) {
        name = 'ProOwnPrice'
      } else {
        name = 'ProNoOwnPrice'
      }
      this.$router.push({
        name,
        query: {
          proId: this.proId,
          optionId: this.optionId,
          catalogId: this.catalogId,
          ratePlanId: ratePlanId,
          proSource: this.proSource,
          optionName: this.optionName
        }
      })
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

.mr5 {
  margin-right: 5px;
}
</style>